import { useLocation, useParams, useRouteError } from 'react-router'
import { ErrorBoundary } from '#/components/error-boundary'
import { Head } from '#/components/head'
import { Button } from '#/components/ui/button'
import { Separator } from '#/components/ui/separator'
import { Heading } from '#/components/ui/typography'


export default function StickerError() {
  const params = useParams() as { stickerId: string }
  const { state } = useLocation()
  const error = useRouteError()

  // Display name might be available from nav state
  const stickerName = state?.name ?? params.stickerId

  return (
    <div className="flex grow flex-col gap-4 items-start">

      <Head title={stickerName} />

      <div className="flex w-full items-end justify-between gap-4">
        <Heading>{stickerName}</Heading>
        <Button className="invisible" />
      </div>

      <Separator />

      <ErrorBoundary error={error} />

    </div>
  )
}
